import { useApiQuery, useOwnerPortalContact } from '@vrplatform/data';

/**
 * Reads the selected owner contact over REST so owner sessions and preview
 * tokens share one request. Archived owners keep read-only statements but lose
 * the rest of the portal.
 */
export function useOwnerPortalSelectedContact(options?: { skip: boolean }) {
  const { contactId } = useOwnerPortalContact();

  return useApiQuery(
    async (api, signal, args) => {
      if (!args.contactId) throw new Error('No owner contact is selected');

      const result = await api.GET('/contacts/{id}', {
        params: { path: { id: args.contactId } },
        signal,
      });

      if (result.error) throw result.error;

      return result.data;
    },
    {
      variables: { contactId },
      skip: options?.skip || !contactId,
      queryGroup: 'owners',
      uniqueQueryKey: 'owner-portal-selected-contact',
    }
  );
}
